import { useQuery } from "@tanstack/react-query";
import getConfigOption, { CONFIG_OPTION_TYPES } from "api/bookAppointmentOnline/get-config-option";

const CONFIGURATION_OPTION_KEY = "configuration_option_key"
export default function useGetConfigurationOption(option: CONFIG_OPTION_TYPES[]) {
    return useQuery({
        queryKey: [CONFIGURATION_OPTION_KEY, option],
        queryFn: () => getConfigOption(option),
        enabled: !!option
    });
}
